/**
 * The deterministic transaction id for a delete/cut gesture, paired with the flat list of ids
 * it encodes. Delete and Cut both need the pair — the txnId groups the gesture's history
 * entries into one undo step, the id list is what `onDeleteGestureScope` announces — so they
 * are derived together here rather than rebuilt per route, which is how they stay in lockstep.
 *
 * Covers the selection only. A group delete additionally cascades to the selected groups'
 * descendants (`deleteSelectedShape`'s own `toDelete` walk) and to captions beneath deleted
 * shapes; neither is enumerated here, so a chain member removed purely as a cascade victim is
 * not announced.
 */
export function computeDeleteGestureScope(
  shapeSnapshots: readonly { id: string }[],
  textSnapshots: readonly { id: string }[]
): { txnId: string; ids: string[] } {
  const ids = [...shapeSnapshots.map((s) => s.id).sort(), ...textSnapshots.map((t) => t.id).sort()]

  return { txnId: `delete:${ids.join('|')}`, ids }
}
